import apiClient from './api';

const debtService = {
  getAll: async () => apiClient.get('/debts'),
  create: async (debtData) => apiClient.post('/debts', debtData),
  update: async (id, debtData) => apiClient.put(`/debts/${id}`, debtData),
  delete: async (id) => apiClient.delete(`/debts/${id}`),
  // 26 sep 2026: junta dos filas que son la misma tarjeta (ver
  // unir_deudas en endpoints/debts.py). No pierde movimientos.
  unir: async (origenId, destinoId) =>
    apiClient.post(`/debts/${origenId}/unir`, { destino_id: destinoId }),
  // Tarjetas partidas en dos por el importador. Ojo: puede haber DOS
  // tarjetas como cuenta y UNA sola como deuda (ver tarjetas_duplicadas),
  // así que esto mira las cuentas, no las deudas.
  duplicadas: async () => apiClient.get('/debts/tarjetas-duplicadas'),
  unirCuentas: async (origenId, destinoId) =>
    apiClient.post(`/dashboard/accounts/${origenId}/unir`, { destino_id: destinoId }),
  getByType: async (type) => apiClient.get(`/debts/type/${type}`),
  // 4 sep 2026 (Augusto: "registré una transferencia... no se ve una
  // reducción de deuda"): resta un pago directo del monto de la deuda --
  // ver comentario en backend_new/app/schemas/debt.py::DebtPago.
  registrarPago: async (id, monto) => apiClient.post(`/debts/${id}/pago`, { monto }),
  getSummary: async () => apiClient.get('/debts/summary'),
  getMonthlyPayments: async () => apiClient.get('/debts/monthly-payments'),
};

export default debtService;
